import React, { Component } from "react";

import { Reveal } from "react-awesome-reveal";
import { keyframes } from "@emotion/react";
import DatePicker from "react-datepicker";
import { Icon } from "@iconify/react";
import moment from "moment";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { isDesktop } from "react-device-detect";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { withNamespaces } from "react-i18next";

import SideBar from "../../components/Sidebar/Sidebar";
import EditModal from "./EditModal";
import EditSecurityAns from "./EditSecurityAns";
import BindingAuth from "./BindingAuthenticator";
import MobilePersonalDetails from "./MobilePersonalDetails";

import { getUserData } from "../../store/ducks/currentUser/actions";
import {
    deactiveGoogleAuthenticator,
    getAgentProfile,
    updateAgentName,
    updateAgentDOB,
    generateEmailOTP,
    verifyEmailOTP,
    generateSMSOTP,
    verifySMSOTP,
    resendOTP,
    updateMemberPassword,
    setAgentPaymentPassword,
    updateAgentPaymentPassword,
    removePaymentPassword,
    verifyPaymentPassword
} from "../../store/ducks/profile/actions";
import { getCountry } from "../../store/ducks/home/actions";

import * as CryptoJS from "crypto-js";

let countryArry = [];
let contact_no_min_limits = 9;
let contact_no_max_limits = 10;
export class PersonalDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            personalInfo: {
                name: "",
                real_name: "",
                mobile_no: "*********99",
                email: "ic********@gmail.com",
                birthday: "",
            },

            birthday: "",
            real_name: "",
            mobile_no: "",
            email: "",
            mobileVarificationCode: "",
            emailVarificationCode: "",

            payment_password: "",
            forgetPaymentPasswordStatus: false,
            forgetPaymentPasswordChangeStatus: false,
            verifyPaymentPasswordStatus: false,

            login_old_pass: "",
            login_new_pass: "",
            login_confirm_pass: "",

            openEditModal: false,
            editModalContent: "",

            showEditSecurityAns: false,
            showBindingAuth: false,
            googleAuthenticateStatus: 0,
            emailVerifiedStatus: 0,
            contactVerifiedStatus: 0,
            paymentPasswordStatus: 0,
            subordinateMembers: 0,
            downlineAgents: 0,

            currentMobileNo: this.props.currentUser.data.contact_no ? this.props.currentUser.data.contact_no.substr(2) : "",
            currentMobileDialCode: "",
            check_sending_sms_times: "",
            check_sending_sms_status: true,
            time: {},
            seconds: 180,
            timer: 0,
            generateOTPStatus: false,
            resend_otp_button_disabled: true,

            referralCode: "",
            errorMsg: [],
        };
    }

    componentDidMount() {
        this.props.getCountry();

        let data = {};
        data.agent_id = this.props.currentUser.data.id;

        this.props.getAgentProfile(data);
    }

    shouldComponentUpdate(nextProps, nextState) {
        const { t } = this.props;

        if (nextProps.countryData !== undefined) {
            if (nextProps.countryData !== this.props.countryData) {
                let countryData = nextProps.countryData.country;
                countryArry = [];
                // mobileCountryArray = [];
                Object.keys(countryData).forEach((item, i) => {
                    if (this.props.currentUser.data.country_code === countryData[item].countryShortCode) {
                        this.setState({
                            currentCountryId: countryData[item].countryId,
                            currentMobileDialCode: countryData[item].dialCode,
                        });

                        countryArry.push({
                            label: countryData[item].dialCode,
                            value: countryData[item].countryId,
                            code: countryData[item].countryShortCode
                        });
                        // mobileCountryArray.push({
                        //     code: countryData[item].countryShortCode,
                        //     label: countryData[item].dialCode,
                        //     value: countryData[item].countryId,
                        //     details: { label: countryData[item].countryName + countryData[item].dialCode, value: countryData[item].countryId },
                        // });
                    }
                });
            }
        }

        if (nextProps.get_agent_profile !== this.props.get_agent_profile) {
            if (nextProps.get_agent_profile.responseCode === 200) {
                this.setState({
                    googleAuthenticateStatus: nextProps.get_agent_profile.data.agentProfile[0].googleAuthenticatorStatus,
                    personalInfo: {
                        name: nextProps.get_agent_profile.data.agentProfile[0].username,
                        real_name: (nextProps.get_agent_profile.data.agentProfile[0].name) ? nextProps.get_agent_profile.data.agentProfile[0].name : "" ,
                        mobile_no: (nextProps.get_agent_profile.data.agentProfile[0].contactNo) ? nextProps.get_agent_profile.data.agentProfile[0].contactNo : "",
                        email: (nextProps.get_agent_profile.data.agentProfile[0].email) ? nextProps.get_agent_profile.data.agentProfile[0].email : "",
                        birthday: nextProps.get_agent_profile.data.agentProfile[0].dob,
                    },
                    referralCode: nextProps.get_agent_profile.data.agentProfile[0].referralCode,
                    emailVerifiedStatus: nextProps.get_agent_profile.data.agentProfile[0].emailVerified,
                    contactVerifiedStatus: nextProps.get_agent_profile.data.agentProfile[0].contactVerified,
                    email: (nextProps.get_agent_profile.data.agentProfile[0].email) ? nextProps.get_agent_profile.data.agentProfile[0].email : "",
                    paymentPasswordStatus: nextProps.get_agent_profile.data.agentProfile[0].paymentPasswordStatus,
                    subordinateMembers: nextProps.get_agent_profile.data.agentProfile[0].subordinateMembers,
                    downlineAgents: nextProps.get_agent_profile.data.agentProfile[0].downlineAgents,
                    editModalContent: (!isDesktop && nextProps.get_agent_profile.data.agentProfile[0].paymentPasswordStatus === 1) ? 'update_payment_password' : (!isDesktop && nextProps.get_agent_profile.data.agentProfile[0].paymentPasswordStatus === 0) ? "payment_pass": ""
                });
            } else {
                this.setState({ loading: false });
                Swal.fire({
                    iconHtml: !isDesktop ? '<img src="https://api.iconify.design/fa6-solid:face-sad-tear.svg?color=%23b0b0b0">' : "",
                    title: t("global.sorry"),
                    text: nextProps.get_agent_profile.data.message[0],
                    // icon: nextProps.register_data.data.msgType,
                    icon: "error",
                    confirmButtonText: t("global.ok"),
                    customClass: !isDesktop
                        ? {
                              container: "swal-mobile-container sorry",
                              icon: "swal-sorry-icon",
                          }
                        : [],
                });
            }
        }

        if (nextProps.deactive_google_authenticator !== this.props.deactive_google_authenticator) {
            if (nextProps.deactive_google_authenticator.responseCode === 200) {
                Swal.fire({
                    iconHtml: !isDesktop ? '<img src="https://api.iconify.design/mdi:check.svg?color=%23ffffff">' : "",
                    icon: "success",
                    title: t("global.success"),
                    text: nextProps.deactive_google_authenticator.message,
                    confirmButtonText: t("global.ok"),
                    customClass: !isDesktop
                        ? {
                              container: "swal-mobile-container sucess",
                              icon: "swal-success-icon",
                          }
                        : [],
                }).then((result) => {
                    if (result.isConfirmed) {
                        let data = {};
                        data.agent_id = this.props.currentUser.data.id;

                        this.props.getAgentProfile(data);

                        this.props.history.push("/personal-details");
                    }
                });
            } else {
                this.setState({ loading: false });
                Swal.fire({
                    iconHtml: !isDesktop ? '<img src="https://api.iconify.design/fa6-solid:face-sad-tear.svg?color=%23b0b0b0">' : "",
                    title: t("global.sorry"),
                    text: nextProps.deactive_google_authenticator.data.message[0],
                    // icon: nextProps.register_data.data.msgType,
                    icon: "error",
                    confirmButtonText: t("global.ok"),
                    customClass: !isDesktop
                        ? {
                              container: "swal-mobile-container sorry",
                              icon: "swal-sorry-icon",
                          }
                        : [],
                });
            }
        }

        if (nextProps.update_agent_name !== this.props.update_agent_name) {
            if (nextProps.update_agent_name.responseCode === 200) {
                this.setState({ editModalContent: "", openEditModal: false });

                Swal.fire({
                    iconHtml: !isDesktop ? '<img src="https://api.iconify.design/mdi:check.svg?color=%23ffffff">' : "",
                    icon: "success",
                    title: t("global.success"),
                    text: nextProps.update_agent_name.message,
                    confirmButtonText: t("global.ok"),
                    customClass: !isDesktop
                        ? {
                              container: "swal-mobile-container sorry",
                              icon: "swal-sorry-icon",
                          }
                        : [],
                }).then((result) => {
                    if (result.isConfirmed) {
                        let data = {};
                        data.agent_id = this.props.currentUser.data.id;

                        this.props.getAgentProfile(data);

                        this.props.history.push("/personal-details");
                    }
                });
            } else if (nextProps.update_agent_name.responseCode === 422) {
                this.setState({
                    loading: false,
                    touched: true,
                    errorMsg: nextProps.update_agent_name.message.input_error || [],
                    formError: true,
                });
                Swal.close();
            } else {
                this.setState({ loading: false });
                Swal.fire({
                    iconHtml: !isDesktop ? '<img src="https://api.iconify.design/fa6-solid:face-sad-tear.svg?color=%23b0b0b0">' : "",
                    title: t("global.sorry"),
                    text: nextProps.update_agent_name.message.input_error.name,
                    // icon: nextProps.register_data.data.msgType,
                    icon: "error",
                    confirmButtonText: t("global.ok"),
                    customClass: !isDesktop
                        ? {
                              container: "swal-mobile-container sorry",
                              icon: "swal-sorry-icon",
                          }
                        : [],
                });
            }
        }

        if (nextProps.update_agent_dob !== this.props.update_agent_dob) {
            if (nextProps.update_agent_dob.responseCode === 200) {
                Swal.fire({
                    iconHtml: !isDesktop ? '<img src="https://api.iconify.design/mdi:check.svg?color=%23ffffff">' : "",
                    icon: "success",
                    title: t("global.success"),
                    text: nextProps.update_agent_dob.message,
                    confirmButtonText: t("global.ok"),
                    customClass: !isDesktop
                        ? {
                              container: "swal-mobile-container sorry",
                              icon: "swal-sorry-icon",
                          }
                        : [],
                }).then((result) => {
                    if (result.isConfirmed) {
                        window.location.reload();
                    }
                });
            } else if (nextProps.update_agent_dob.responseCode === 422) {
                this.setState({
                    loading: false,
                    touched: true,
                    errorMsg: nextProps.update_agent_dob.message.input_error || [],
                    formError: true,
                });
                Swal.close();
            } else {
                this.setState({ loading: false });
                Swal.fire({
                    iconHtml: !isDesktop ? '<img src="https://api.iconify.design/fa6-solid:face-sad-tear.svg?color=%23b0b0b0">' : "",
                    title: t("global.sorry"),
                    text: nextProps.update_agent_dob.message.input_error.dob,
                    // icon: nextProps.register_data.data.msgType,
                    icon: "error",
                    confirmButtonText: t("global.ok"),
                    customClass: !isDesktop
                        ? {
                              container: "swal-mobile-container sorry",
                              icon: "swal-sorry-icon",
                          }
                        : [],
                });
            }
        }

        if (nextProps.generate_email_otp_result !== this.props.generate_email_otp_result) {
            if (nextProps.generate_email_otp_result.responseCode === 200) {
                Swal.fire({
                    iconHtml: !isDesktop ? '<img src="https://api.iconify.design/mdi:check.svg?color=%23ffffff">' : "",
                    icon: "success",
                    title: t("global.success"),
                    text: nextProps.generate_email_otp_result.message,
                    confirmButtonText: t("global.ok"),
                    customClass: !isDesktop
                        ? {
                              container: "swal-mobile-container sorry",
                              icon: "swal-sorry-icon",
                          }
                        : [],
                });
            } else if (nextProps.generate_email_otp_result.responseCode === 422) {
                this.setState({
                    loading: false,
                    touched: true,
                    errorMsg: nextProps.generate_email_otp_result.message || [],
                    formError: true,
                });
                Swal.close();
            } else {
                this.setState({ loading: false });
                Swal.fire({
                    iconHtml: !isDesktop ? '<img src="https://api.iconify.design/fa6-solid:face-sad-tear.svg?color=%23b0b0b0">' : "",
                    title: t("global.sorry"),
                    text: nextProps.generate_email_otp_result.message || [],
                    // icon: nextProps.register_data.data.msgType,
                    icon: "error",
                    confirmButtonText: t("global.ok"),
                    customClass: !isDesktop
                        ? {
                              container: "swal-mobile-container sorry",
                              icon: "swal-sorry-icon",
                          }
                        : [],
                });
            }
        }

        if (nextProps.verify_email_otp_result !== this.props.verify_email_otp_result) {
            if (nextProps.verify_email_otp_result.responseCode === 200) {
                Swal.fire({
                    iconHtml: !isDesktop ? '<img src="https://api.iconify.design/mdi:check.svg?color=%23ffffff">' : "",
                    icon: "success",
                    title: t("global.success"),
                    text: t("profile.email-verify-otp-success"),
                    confirmButtonText: t("global.ok"),
                    customClass: !isDesktop
                        ? {
                              container: "swal-mobile-container sorry",
                              icon: "swal-sorry-icon",
                          }
                        : [],    
                }).then((result) => {
                    if (result.isConfirmed) {
                        Swal.close();

                        this.setState({ editModalContent: "", openEditModal: false });

                        window.location.reload();
                    }
                    // this.setState({ generateEmailOTP: false, openEmailModal: false });
                });
            } else {
                this.setState({ loading: false });
                Swal.fire({
                    iconHtml: !isDesktop ? '<img src="https://api.iconify.design/fa6-solid:face-sad-tear.svg?color=%23b0b0b0">' : "",
                    title: t("global.sorry"),
                    text: nextProps.verify_email_otp_result.message || [],
                    // icon: nextProps.register_data.data.msgType,
                    icon: "error",
                    confirmButtonText: t("global.ok"),
                    customClass: !isDesktop
                        ? {
                              container: "swal-mobile-container sorry",
                              icon: "swal-sorry-icon",
                          }
                        : [],
                });
            }
        }

        if (nextProps.generate_sms_otp_result !== this.props.generate_sms_otp_result) {
            if (nextProps.generate_sms_otp_result.responseCode === 200) {
                if (!nextProps.generate_sms_otp_result.data.sms_reached_limit) {
                    let timeLeftVar = this.secondsToTime(this.state.seconds);

                    this.setState({ time: timeLeftVar });

                    this.startTimer();
                }

                this.setState({
                    generateOTPStatus: true,
                    check_sending_sms_times: nextProps.generate_sms_otp_result.data.count_sending_sms_times,
                    check_sending_sms_status: nextProps.generate_sms_otp_result.data.sms_reached_limit === true ? false : true,
                    resend_otp_button_disabled: true,
                });

                if (isDesktop) {
                    Swal.fire({
                        // icon: nextProps.generate_sms_otp_result.msgType,
                        icon: "success",
                        title: t("global.success"),
                        html: nextProps.generate_sms_otp_result.data.sms_reached_limit === true ? t("profile.reached-sms-limit") : t("profile.generate-sms-otp-success"),
                        showConfirmButton: true,
                        confirmButtonText: t("global.ok"),
                    }).then((result) => {
                        if (result.isConfirmed) {
                            Swal.close();
                        }
                    });
                } else {
                    Swal.fire({
                        iconHtml: '<img src="https://api.iconify.design/mdi:check.svg?color=%23ffffff">',
                        // icon: nextProps.generate_sms_otp_result.msgType,
                        icon: "success",
                        title: t("global.success"),
                        html: nextProps.generate_sms_otp_result.data.sms_reached_limit === true ? t("profile.reached-sms-limit") : t("profile.generate-sms-otp-success"),
                        showConfirmButton: true,
                        confirmButtonText: t("global.ok"),
                        customClass: {
                            container: "swal-mobile-container sucess",
                            icon: "swal-success-icon",
                        },
                    }).then((result) => {
                        if (result.isConfirmed) {
                            Swal.close();
                        }
                    });
                }
            } else {
                if (!isDesktop) {
                    Swal.fire({
                        iconHtml: '<img src="https://api.iconify.design/fa6-solid:face-sad-tear.svg?color=%23b0b0b0">',
                        icon: "error",
                        title: t("global.sorry"),
                        text: nextProps.generate_sms_otp_result.message,
                        customClass: {
                            container: "swal-mobile-container sorry",
                            icon: "swal-sorry-icon",
                        },
                    }).then((result) => {
                        if (result.isConfirmed) {
                            this.setState({
                                touched: true,
                                errorMsg: nextProps.generate_sms_otp_result.message || [],
                                formError: true,
                            });
                        }
                    });
                } else {
                    this.setState({
                        touched: true,
                        errorMsg: nextProps.generate_sms_otp_result.message.input_error || [],
                        formError: true,
                    });
                    Swal.close();
                }
            }
        }

        if (nextProps.verify_sms_otp_result !== this.props.verify_sms_otp_result) {
            if (nextProps.verify_sms_otp_result.responseCode === 200) {
                if (isDesktop) {
                    Swal.fire({
                        // icon: nextProps.verify_sms_otp_result.msgType,
                        icon: "success",
                        title: t("global.success"),
                        html: t("profile.verify-sms-otp-success"),
                        showConfirmButton: true,
                        confirmButtonText: t("global.ok"),
                    }).then((result) => {
                        if (result.isConfirmed) {
                            Swal.close();

                            this.setState({ editModalContent: "", openEditModal: false, mobileVarificationCode: "" });

                            if(this.state.forgetPaymentPasswordStatus === false){
                                window.location.reload();
                            }else{
                                this.toggleEditModal("payment_pass");
                            }                            
                        }
                        // this.setState({ generateOTPStatus: false, openMobileModal: false });
                    });
                } else {
                    Swal.fire({
                        iconHtml: '<img src="https://api.iconify.design/mdi:check.svg?color=%23ffffff">',
                        title: t("global.success"),
                        icon: "success",
                        html: t("profile.verify-sms-otp-success"),
                        showConfirmButton: true,
                        confirmButtonText: t("global.ok"),
                        customClass: {
                            container: "swal-mobile-container sucess",
                            icon: "swal-success-icon",
                        },
                    }).then((result) => {
                        if (result.isConfirmed) {
                            Swal.close();

                            this.setState({ editModalContent: "", openEditModal: false });
    
                            if(this.state.forgetPaymentPasswordStatus === false){
                                window.location.reload();
                            }else{
                                this.setState({ forgetPaymentPasswordChangeStatus: true });
                            }
                        }
                        // this.setState({ generateOTPStatus: false, openMobileModal: false });
                    });
                }
                const contact_number = this.state.currentMobileDialCode + this.state.currentMobileNo;
                const data = this.props.currentUser.data;
                data.contact_no = contact_number.replace(/^\+/, "").replace(/ /g, "");
                this.props.getUserData(data);
            } else {
                if (!isDesktop) {
                    Swal.fire({
                        iconHtml: '<img src="https://api.iconify.design/fa6-solid:face-sad-tear.svg?color=%23b0b0b0">',
                        icon: "error",
                        title: t("global.sorry"),
                        text: nextProps.verify_sms_otp_result.message[0],
                        customClass: {
                            container: "swal-mobile-container sorry",
                            icon: "swal-sorry-icon",
                        },
                    }).then((result) => {
                        if (result.isConfirmed) {
                            this.setState({
                                touched: true,
                                errorMsg: nextProps.verify_sms_otp_result.message[0] || [],
                                formError: true,
                            });
                        }
                    });
                } else {
                    Swal.fire({
                        iconHtml: !isDesktop ? '<img src="https://api.iconify.design/fa6-solid:face-sad-tear.svg?color=%23b0b0b0">' : "",
                        icon: "error",
                        title: t("global.sorry"),
                        text: nextProps.verify_sms_otp_result.message[0],
                        customClass: !isDesktop
                        ? {
                              container: "swal-mobile-container sorry",
                              icon: "swal-sorry-icon",
                          }
                        : [],
                    });
                }
            }
        }

        if (nextProps.resend_otp_result !== this.props.resend_otp_result) {
            if (nextProps.resend_otp_result.responseCode === 200) {
                if (nextProps.resend_otp_result.data.sms_reached_limit === true) {
                    this.setState({ check_sending_sms_status: false });
                    Swal.close();
                } else {
                    if (isDesktop) {
                        Swal.fire({
                            // icon: nextProps.resend_otp_result.msgType,
                            icon: "success",
                            title: t("global.success"),
                            html: t("profile.resend-otp-success"),
                            showConfirmButton: true,
                            confirmButtonText: t("global.ok"),
                        }).then(() => {
                            this.setState({
                                generateOTPStatus: true,
                                openMobileModal: true,
                                check_sending_sms_times: nextProps.resend_otp_result.data.count_sending_sms_times,
                                seconds: 180,
                                timer: 0,
                                resend_otp_button_disabled: true,
                            });
                        });
                    } else {
                        Swal.fire({
                            iconHtml: '<img src="https://api.iconify.design/mdi:check.svg?color=%23ffffff">',
                            title: t("global.success"),
                            icon: "success",
                            html: t("profile.resend-otp-success"),
                            showConfirmButton: true,
                            confirmButtonText: t("global.ok"),
                            customClass: {
                                container: "swal-mobile-container sucess",
                                icon: "swal-success-icon",
                            },
                        }).then(() => {
                            this.setState({
                                generateOTPStatus: true,
                                openMobileModal: true,
                                check_sending_sms_times: nextProps.resend_otp_result.data.count_sending_sms_times,
                                seconds: 180,
                                timer: 0,
                                resend_otp_button_disabled: true,
                            });
                        });
                    }
                }
            } else {
                if (!isDesktop) {
                    Swal.fire({
                        iconHtml: '<img src="https://api.iconify.design/mdi:close.svg?color=%23ffffff">',
                        icon: "error",
                        title: t("global.failed"),
                        html: nextProps.resend_otp_result.message,
                        showConfirmButton: true,
                        confirmButtonText: t("global.ok"),
                        customClass: {
                            container: "swal-mobile-container failed",
                            icon: "swal-failed-icon",
                        },
                    }).then(() => {
                        this.setState({
                            touched: true,
                            errorMsg: nextProps.resend_otp_result.message || [],
                            formError: true,
                            resend_otp_button_disabled: true,
                        });
                        Swal.close();
                    });
                }
                this.setState({
                    touched: true,
                    errorMsg: nextProps.resend_otp_result.message.input_error || [],
                    formError: true,
                    resend_otp_button_disabled: true,
                });
                Swal.close();
            }
        }

        if (nextProps.member_update_password_result !== this.props.member_update_password_result) {
            if (nextProps.member_update_password_result.responseCode === 200) {
                const { t } = this.props;

                if (isDesktop) {
                    Swal.fire({
                        title: t("global.success"),
                        text: t("global.record-updated"),
                        icon: "success",
                        confirmButtonText: t("global.ok"),
                    }).then((result) => {
                        if (result.isConfirmed) {
                            Swal.close();

                            this.setState({ editModalContent: "", openEditModal: false, mobileVarificationCode: "" });

                            window.location.reload();
                        }
                    });
                } else {
                    Swal.fire({
                        iconHtml: '<img src="https://api.iconify.design/mdi:check.svg?color=%23ffffff">',
                        title: t("global.success"),
                        icon: "success",
                        text: t("global.record-updated"),
                        confirmButtonText: t("global.ok"),
                        customClass: {
                            container: "swal-mobile-container sucess",
                            icon: "swal-success-icon",
                        },
                    }).then((result) => {
                        if (result.isConfirmed) {
                            this.setState({
                                current_password: "",
                                new_password: "",
                                confirm_password: "",
                                touched: false,
                                errorMsg: [],
                            });

                            Swal.close();

                            window.location.reload();
                            
                        }
                    });
                }
            } else if (nextProps.member_update_password_result.responseCode === 422) {
                // if (!isDesktop) {
                //     Swal.fire({
                //         iconHtml: '<img src="https://api.iconify.design/fa6-solid:face-sad-tear.svg?color=%23b0b0b0">',
                //         title: t("global.sorry"),
                //         text: nextProps.memberUpdatePasswordResult.message,
                //         // nextProps.memberUpdatePasswordResult.message.input_error.new_password ||
                //         // nextProps.memberUpdatePasswordResult.message.input_error.confirm_password,
                //         customClass: {
                //             container: "swal-mobile-container sorry",
                //             icon: "swal-sorry-icon",
                //         },
                //     }).then((result) => {
                //         if (result.isConfirmed) {
                //             this.setState({
                //                 touched: true,
                //                 errorMsg: nextProps.memberUpdatePasswordResult.message.input_error || [],
                //                 formError: true,
                //             });
                //         }
                //     });
                // } else {
                this.setState({
                    touched: true,
                    errorMsg: nextProps.member_update_password_result.message.input_error || [],
                    formError: true,
                });
                Swal.close();
                // }
            } else {
                this.setState({
                    touched: true,
                    errorMsg: nextProps.member_update_password_result.message.input_error || [],
                    formError: true,
                });
                Swal.close();
            }
        }

        if (nextProps.set_agent_payment_password_result !== this.props.set_agent_payment_password_result) {
          if (nextProps.set_agent_payment_password_result.responseCode === 200) {
              const { t } = this.props;

              if (isDesktop) {
                  Swal.fire({
                      title: t("global.success"),
                      text: t("global.record-updated"),
                      icon: "success",
                      confirmButtonText: t("global.ok"),
                  }).then((result) => {
                      if (result.isConfirmed) {
                          Swal.close();

                          this.setState({ editModalContent: "", openEditModal: false, mobileVarificationCode: "" });

                          window.location.reload();
                      }
                  });
              } else {
                  Swal.fire({
                      iconHtml: '<img src="https://api.iconify.design/mdi:check.svg?color=%23ffffff">',
                      title: t("global.success"),
                      icon: "success",
                      text: t("global.record-updated"),
                      confirmButtonText: t("global.ok"),
                      customClass: {
                          container: "swal-mobile-container sucess",
                          icon: "swal-success-icon",
                      },
                  }).then((result) => {
                      if (result.isConfirmed) {
                          this.setState({
                              current_password: "",
                              new_password: "",
                              confirm_password: "",
                              touched: false,
                              errorMsg: [],
                          });

                          Swal.close();

                          window.location.reload();
                      }
                  });
              }
          } else if (nextProps.set_agent_payment_password_result.responseCode === 422) {
                Swal.fire({
                    iconHtml: !isDesktop ? '<img src="https://api.iconify.design/fa6-solid:face-sad-tear.svg?color=%23b0b0b0">' : "",
                    title: t("global.sorry"),
                    text: nextProps.set_agent_payment_password_result.message[0],
                    // icon: nextProps.register_data.data.msgType,
                    icon: "error",
                    confirmButtonText: t("global.ok"),
                    customClass: !isDesktop
                        ? {
                            container: "swal-mobile-container sorry",
                            icon: "swal-sorry-icon",
                        }
                        : [],
                });
            //   else {
            //   this.setState({
            //       touched: true,
            //       errorMsg: nextProps.set_agent_payment_password_result.message.input_error || [],
            //       formError: true,
            //   });
            //   Swal.close();
              // }
          } else {
              return false;
          }
      }

      if (nextProps.update_agent_payment_password_result !== this.props.update_agent_payment_password_result) {
        if (nextProps.update_agent_payment_password_result.responseCode === 200) {
            const { t } = this.props;

            if (isDesktop) {
                Swal.fire({
                    title: t("global.success"),
                    text: t("global.record-updated"),
                    icon: "success",
                    confirmButtonText: t("global.ok"),
                }).then((result) => {
                    if (result.isConfirmed) {
                        Swal.close();

                        this.setState({ editModalContent: "", openEditModal: false, mobileVarificationCode: "" });

                        window.location.reload();
                    }
                });
            } else {
                Swal.fire({
                    iconHtml: '<img src="https://api.iconify.design/mdi:check.svg?color=%23ffffff">',
                    title: t("global.success"),
                    icon: "success",
                    text: t("global.record-updated"),
                    confirmButtonText: t("global.ok"),
                    customClass: {
                        container: "swal-mobile-container sucess",
                        icon: "swal-success-icon",
                    },
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.setState({
                            current_password: "",
                            new_password: "",
                            confirm_password: "",
                            touched: false,
                            errorMsg: [],
                        });

                        Swal.close();

                        window.location.reload();
                    }
                });
            }
        } else if (nextProps.update_agent_payment_password_result.responseCode === 422) {
            Swal.fire({
                iconHtml: !isDesktop ? '<img src="https://api.iconify.design/fa6-solid:face-sad-tear.svg?color=%23b0b0b0">' : "",
                title: t("global.sorry"),
                text: nextProps.update_agent_payment_password_result.message[0],
                // icon: nextProps.register_data.data.msgType,
                icon: "error",
                confirmButtonText: t("global.ok"),
                customClass: !isDesktop
                    ? {
                        container: "swal-mobile-container sorry",
                        icon: "swal-sorry-icon",
                    }
                    : [],
            });
        } else {
            return false;
        }
    }

    if (nextProps.remove_payment_password_result !== this.props.remove_payment_password_result) {
        if (nextProps.remove_payment_password_result.responseCode === 200) {
            const { t } = this.props;

            if (isDesktop) {
                Swal.fire({
                    title: t("global.success"),
                    text: t("global.record-updated"),
                    icon: "success",
                    confirmButtonText: t("global.ok"),
                }).then((result) => {
                    if (result.isConfirmed) {
                        Swal.close();

                        this.setState({ editModalContent: "", openEditModal: false, mobileVarificationCode: "" });

                        window.location.reload();
                    }
                });
            } else {
                Swal.fire({
                    iconHtml: '<img src="https://api.iconify.design/mdi:check.svg?color=%23ffffff">',
                    title: t("global.success"),
                    icon: "success",
                    text: t("global.record-updated"),
                    confirmButtonText: t("global.ok"),
                    customClass: {
                        container: "swal-mobile-container sucess",
                        icon: "swal-success-icon",
                    },
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.setState({
                            current_password: "",
                            new_password: "",
                            confirm_password: "",
                            touched: false,
                            errorMsg: [],
                        });

                        Swal.close();

                        window.location.reload();
                    }
                });
            }
        } else {
            Swal.fire({
                iconHtml: !isDesktop ? '<img src="https://api.iconify.design/fa6-solid:face-sad-tear.svg?color=%23b0b0b0">' : "",
                title: t("global.sorry"),
                text: nextProps.remove_payment_password_result.message[0],
                // icon: nextProps.register_data.data.msgType,
                icon: "error",
                confirmButtonText: t("global.ok"),
                customClass: !isDesktop
                    ? {
                        container: "swal-mobile-container sorry",
                        icon: "swal-sorry-icon",
                    }
                    : [],
            });
        }
    }

    if (nextProps.verify_payment_password_result !== this.props.verify_payment_password_result) {
        if (isDesktop) {
            if (nextProps.verify_payment_password_result.responseCode === 200) {
                Swal.fire({
                    // icon: nextProps.verify_security_pin_result.msgType,
                    icon: "success",
                    title: t("global.success"),
                    html: nextProps.verify_payment_password_result.message[0],
                    showConfirmButton: true,
                    confirmButtonText: t("global.ok"),
                }).then((result) => {
                    if (result.isConfirmed) {
                        if (nextProps.verify_payment_password_result.data.verify_payment_password_status === true) {
                            Swal.close();
                            this.setState({
                                verifyPaymentPasswordStatus: true,
                                payment_password: "",
                            });
                            // Array.from(this.ref.current.children).forEach((input) => (input.value = ""));
                            // this.ref.current.children[0].focus();
                            // this.props.getMemberProfile();
                            // window.location.reload();
                        }
                    }
                });
            } else {
                Swal.fire({
                    // icon: nextProps.verify_security_pin_result.msgType,
                    icon: "error",
                    title: t("global.error"),
                    html: nextProps.verify_payment_password_result.message[0],
                    showConfirmButton: true,
                    confirmButtonText: t("global.ok"),
                }).then(() => {
                    this.setState({
                        touched: true,
                        errorMsg: nextProps.verify_payment_password_result.message.input_error || [],
                        formError: true,
                    });

                    // Array.from(this.ref.current.children).forEach((input) => (input.value = ""));
                    // this.ref.current.children[0].focus();

                    Swal.close();
                });
            }
        } else {
            if (nextProps.verify_payment_password_result.responseCode === 200) {
                Swal.fire({
                    iconHtml: '<img src="https://api.iconify.design/mdi:check.svg?color=%23ffffff">',
                    icon: "success",
                    title: t("global.success"),
                    html: nextProps.verify_payment_password_result.message[0],
                    showConfirmButton: true,
                    confirmButtonText: t("global.ok"),
                    customClass: {
                        container: "swal-mobile-container sucess",
                        icon: "swal-success-icon",
                    },
                }).then((result) => {
                    if (result.isConfirmed) {
                        if (nextProps.verify_payment_password_result.data.verify_payment_password_status === true) {
                            Swal.close();
                            //Ethan here to reset after enter current security pin to remove the pin field value
                            this.setState({
                                verifyPaymentPasswordStatus: true,
                                payment_password: "",
                            });
                            // Array.from(this.ref.current.children).forEach((input) => (input.value = ""));
                            // this.ref.current.children[0].focus();
                        }
                    }
                });
            } else {
                Swal.fire({
                    iconHtml: '<img src="https://api.iconify.design/fa6-solid:face-sad-tear.svg?color=%23b0b0b0">',
                    icon: "error",
                    title: t("global.sorry"),
                    html: nextProps.verify_payment_password_result.message[0],
                    showConfirmButton: true,
                    confirmButtonText: t("global.ok"),
                    customClass: {
                        container: "swal-mobile-container sorry",
                        icon: "swal-sorry-icon",
                    },
                }).then(() => {
                    this.setState({
                        touched: true,
                        errorMsg: nextProps.verify_payment_password_result.message.input_error || [],
                        formError: true,
                    });

                    // Array.from(this.ref.current.children).forEach((input) => (input.value = ""));
                    // this.ref.current.children[0].focus();

                    Swal.close();
                });
            }
        }
    }


        return true;
    }

    setBirthdayDay = (date) => {
        this.setState({
            birthday: date,
        });
    };

    updatePersonalInfo = (e) => {
        e.preventDefault();

        const { t } = this.props;

        Swal.fire({
            iconHtml: !isDesktop ? '<img src="https://api.iconify.design/ic:outline-question-mark.svg?color=%23ffffff">' : "",
            title: t("global.confirmation"),
            text: t("global.would-you-like-to-proceed") + "?",
            // html: currencyNotification,
            icon: "warning",
            confirmButtonText: t("global.ok"),
            showDenyButton: true,
            denyButtonText: t("global.cancel"),
            customClass: !isDesktop
                ? {
                      container: "swal-mobile-container confirmation",
                      icon: "swal-confirmation-icon",
                  }
                : [],
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: "",
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    allowEnterKey: false,
                    onOpen: () => {
                        Swal.showLoading();
                    },
                });

                let data = {};
                data.agent_id = this.props.currentUser.data.id;
                data.dob = moment(this.state.birthday).format("YYYY-MM-DD");

                this.props.updateAgentDOB(data);
            }
        });
    };

    toggleEditModal = (editContent) => {
        this.setState({
            payment_password: '',
            openEditModal: !this.state.openEditModal,
            editModalContent: editContent,
        });
    };

    //***Update personal details***

    //Update real name
    enterRealName = (e) => {
        let newPersonalInfo = this.state.personalInfo;
        newPersonalInfo["real_name"] = e.target.value;

        this.setState({
            personalInfo: newPersonalInfo,
        });
    };
    updateRealName = (e) => {
        const { t } = this.props;
        e.preventDefault();

        let newPersonalInfo = this.state.personalInfo;
        newPersonalInfo["real_name"] = this.state.real_name;
        this.setState({
            personalInfo: newPersonalInfo,
            openEditModal: false,
        });
        Swal.fire({
            icon: "success",
            title: t("global.success"),
            text: t("profile.update-success"),
            showConfirmButton: true,
            confirmButtonText: t("global.ok"),
            customClass: {
                confirmButton: "w-75",
            },
        });
    };

    //Update Mobile Number
    enterMobileNumber = (e) => {
        this.setState({
            currentMobileNo: e.target.value,
        });
    };
    updateMobileNumber = (e) => {
        const { t } = this.props;
        e.preventDefault();
        if (this.state.varificationCode !== "") {
            let newPersonalInfo = this.state.personalInfo;
            newPersonalInfo["mobile_no"] = this.state.mobile_no;
            this.setState({
                personalInfo: newPersonalInfo,
                openEditModal: false,
            });
            Swal.fire({
                icon: "success",
                title: t("global.success"),
                text: t("profile.update-mobile"),
                showConfirmButton: true,
                confirmButtonText: t("global.ok"),
                customClass: {
                    confirmButton: "w-75",
                },
            });
        } else {
            Swal.fire({
                icon: "error",
                title: t("global.failed"),
                text: t("profile.system-issue"),
                showConfirmButton: true,
                confirmButtonText: t("deposit.try-again"),
                showCancelButton: true,
                customClass: {},
            }).then((result) => {
                if (result.dismiss) {
                    this.setState({
                        openEditModal: false,
                    });
                }
            });
        }
    };

    //Update email
    enterEmail = (e) => {
        this.setState({
            email: e.target.value,
        });
    };

    verifyEmail = (e) => {
        e.preventDefault();
        // if (this.state.varificationCode !== "") {
        //   let newPersonalInfo = this.state.personalInfo;
        //   newPersonalInfo["email"] = this.state.email;
        //   this.setState({
        //     personalInfo: newPersonalInfo,
        //     openEditModal: false,
        //   });
        //   Swal.fire({
        //     icon: "success",
        //     title: "Successful",
        //     text: "Your Email has been update successfully.Thank you.",
        //     showConfirmButton: true,
        //     customClass: {
        //       confirmButton: "w-75",
        //     },
        //   });
        // } else {
        //   Swal.fire({
        //     icon: "error",
        //     title: "Failed",
        //     text: "We have encountered a system issue, sorry for the inconvenience caused. Please try it again.",
        //     showConfirmButton: true,
        //     confirmButtonText: "Try Again",
        //     showCancelButton: true,
        //     customClass: {},
        //   }).then((result) => {
        //     if (result.dismiss) {
        //       this.setState({
        //         openEditModal: false,
        //       });
        //     }
        //   });
        // }

        e.preventDefault();

        const { t } = this.props;

        Swal.fire({
            iconHtml: !isDesktop ? '<img src="https://api.iconify.design/ic:outline-question-mark.svg?color=%23ffffff">' : "",
            title: t("global.confirmation"),
            text: t("global.would-you-like-to-proceed") + "?",
            // html: currencyNotification,
            icon: "warning",
            confirmButtonText: t("global.ok"),
            showDenyButton: true,
            denyButtonText: t("global.cancel"),
            customClass: !isDesktop
                ? {
                      container: "swal-mobile-container confirmation",
                      icon: "swal-confirmation-icon",
                  }
                : [],
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: "",
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    allowEnterKey: false,
                    onOpen: () => {
                        Swal.showLoading();
                    },
                });

                let data = {};
                data.agent_id = this.props.currentUser.data.id;
                data.email = this.state.email;
                data.otp_code = this.state.emailVarificationCode;

                this.props.verifyEmailOTP(data);
            }
        });
    };

    generateEmailOTPHandler = (event) => {
        event.preventDefault();

        const data = {};
        data.email = this.state.email;
        data.language_code = this.props.currentUser.data.language_code;

        Swal.fire({
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
            didOpen: () => {
                Swal.showLoading();
            },
        });

        this.props.generateEmailOTP(data);
    };

    generateOTPHandler = (event) => {
        event.preventDefault();
        const data = {};
        // if (this.state.resend_contact_no === "") {
        data.contact_number = this.state.currentMobileDialCode + this.state.currentMobileNo;

        // } else {
        // data.contact_number = this.state.currentMobileDialCode + this.state.resend_contact_no;
        // }

        data.contact_prefix = this.state.currentMobileDialCode;

        Swal.fire({
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
            didOpen: () => {
                Swal.showLoading();
            },
        });

        this.props.generateSMSOTP(data);
    };

    resendOTPHandler = (event) => {
        event.preventDefault();

        const { t } = this.props;
        if (isDesktop) {
            Swal.fire({
                title: t("global.confirmation"),
                text: t("global.would-you-like-to-proceed") + "?",
                icon: "warning",
                confirmButtonText: t("global.confirm"),
                showDenyButton: true,
                denyButtonText: t("global.cancel"),
            }).then((result) => {
                if (result.isConfirmed) {
                    Swal.fire({
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        allowEnterKey: false,
                        didOpen: () => {
                            Swal.showLoading();
                        },
                    });

                    const data = {};

                    data.contact_number = this.state.currentMobileDialCode + this.state.currentMobileNo;

                    data.contact_prefix = this.state.currentMobileDialCode;

                    this.props.resendOTP(data);

                    this.setState({ seconds: 180 });

                    let timeLeftVar = this.secondsToTime(this.state.seconds);

                    this.setState({ time: timeLeftVar });

                    this.startTimer();
                }
            });
        } else {
            Swal.fire({
                iconHtml: '<img src="https://api.iconify.design/ic:outline-question-mark.svg?color=%23ffffff">',
                icon: "warning",
                title: t("global.confirmation"),
                text: t("global.would-you-like-to-proceed") + "?",
                confirmButtonText: t("global.confirm"),
                showDenyButton: true,
                denyButtonText: t("global.cancel"),
                customClass: {
                    container: "swal-mobile-container confirmation",
                    icon: "swal-confirmation-icon",
                },
            }).then((result) => {
                if (result.isConfirmed) {
                    Swal.fire({
                        title: "",
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        allowEnterKey: false,
                        onOpen: () => {
                            Swal.showLoading();
                        },
                    });

                    const data = {};

                    data.contact_number = this.state.currentMobileDialCode + this.state.currentMobileNo;

                    data.contact_prefix = this.state.currentMobileDialCode;

                    this.props.resendOTP(data);

                    this.setState({ seconds: 180 });

                    let timeLeftVar = this.secondsToTime(this.state.seconds);

                    this.setState({ time: timeLeftVar });

                    this.startTimer();
                }
            });
        }
    };

    verifyOtpHandler = (event) => {
        event.preventDefault();
        const { t } = this.props;

        if (isDesktop) {
            Swal.fire({
                title: t("global.confirmation"),
                text: t("global.would-you-like-to-proceed") + "?",
                icon: "warning",
                confirmButtonText: t("global.confirm"),
                showDenyButton: true,
                denyButtonText: t("global.cancel"),
            }).then((result) => {
                if (result.isConfirmed) {
                    Swal.fire({
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        allowEnterKey: false,
                        didOpen: () => {
                            Swal.showLoading();
                        },
                    });

                    const data = {};

                    // if (this.state.resend_contact_no !== "") {
                    // data.contact_no = this.state.currentMobileDialCode + this.state.resend_contact_no;
                    // } else {
                    data.contact_no = this.state.currentMobileDialCode + this.state.currentMobileNo;
                    // }

                    data.otp_code = this.state.mobileVarificationCode;

                    this.props.verifySMSOTP(data);
                }
            });
        } else {
            Swal.fire({
                iconHtml: '<img src="https://api.iconify.design/ic:outline-question-mark.svg?color=%23ffffff">',
                icon: "warning",
                title: t("global.confirmation"),
                text: t("global.would-you-like-to-proceed") + "?",
                confirmButtonText: t("global.confirm"),
                showCancelButton: true,
                cancelButtonText: t("global.cancel"),
                customClass: {
                    container: "swal-mobile-container confirmation",
                    icon: "swal-confirmation-icon",
                },
            }).then((result) => {
                if (result.isConfirmed) {
                    Swal.fire({
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        allowEnterKey: false,
                        didOpen: () => {
                            Swal.showLoading();
                        },
                    });

                    const data = {};

                    // if (this.state.resend_contact_no !== "") {
                    // data.contact_no = this.state.currentMobileDialCode + this.state.resend_contact_no;
                    // } else {
                    data.contact_no = this.state.currentMobileDialCode + this.state.currentMobileNo;
                    // }

                    data.otp_code = this.state.mobileVarificationCode;

                    this.props.verifySMSOTP(data);
                }
            });
        }
    };

    enterMobileVarificationCode = (e) => {
        this.setState({
            mobileVarificationCode: e.target.value,
        });
    };

    enterEmailVarificationCode = (e) => {
        this.setState({
            emailVarificationCode: e.target.value,
        });
    };

    onChangeDateHandler = (value) => {
        // console.log(`${value.years}-${value.months}-${value.days}`);
        // let newFilter = Object.assign({}, this.state.personalInfo);
        // newFilter["birthday"] = `${value.years}-${value.months}-${value.days}`;
        this.setState({
            birthday: `${value.years}-${value.months}-${value.days}`
        });
    };

    //Update Payment Password
    enterPaymentOldPass = (e) => {
        this.setState({
            payment_old_pass: e.target.value,
        });
    };
    enterPaymentNewPass = (e) => {
        this.setState({
            payment_new_pass: e.target.value,
        });
    };
    enterPaymentConfirmPass = (e) => {
        this.setState({
            payment_confirm_pass: e.target.value,
        });
    };
    updatePaymentPassword = (e) => {
        console.log("updated");
    };

    //Update Login Password
    enterLoginOldPass = (e) => {
        this.setState({
            login_old_pass: e.target.value,
        });
    };
    enterLoginNewPass = (e) => {
        this.setState({
            login_new_pass: e.target.value,
        });
    };
    enterLoginConfirmPass = (e) => {
        this.setState({
            login_confirm_pass: e.target.value,
        });
    };
    updateLoginPassword = (e) => {
        console.log("updated");
    };

    backToPersonalDetails = () => {
        this.setState({
            showBindingAuth: false,
            showEditSecurityAns: false,
        });
    };

    deactiveGoogleAuthenticator = () => {
        const { t } = this.props;

        Swal.fire({
            iconHtml: !isDesktop ? '<img src="https://api.iconify.design/ic:outline-question-mark.svg?color=%23ffffff">' : "",
            title: t("global.confirmation"),
            text: t("global.would-you-like-to-proceed") + "?",
            // html: currencyNotification,
            icon: "warning",
            confirmButtonText: t("global.ok"),
            showDenyButton: true,
            denyButtonText: t("global.cancel"),
            customClass: !isDesktop
                ? {
                      container: "swal-mobile-container confirmation",
                      icon: "swal-confirmation-icon",
                  }
                : [],
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: "",
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    allowEnterKey: false,
                    onOpen: () => {
                        Swal.showLoading();
                    },
                });

                let data = {};
                data.agent_id = this.props.currentUser.data.id;

                this.props.deactiveGoogleAuthenticator(data);
            }
        });
    };

    updateAgentNameHandler = (e) => {
        e.preventDefault();

        const { t } = this.props;

        Swal.fire({
            iconHtml: !isDesktop ? '<img src="https://api.iconify.design/ic:outline-question-mark.svg?color=%23ffffff">' : "",
            title: t("global.confirmation"),
            text: t("global.would-you-like-to-proceed") + "?",
            // html: currencyNotification,
            icon: "warning",
            confirmButtonText: t("global.ok"),
            showDenyButton: true,
            denyButtonText: t("global.cancel"),
            customClass: !isDesktop
                ? {
                      container: "swal-mobile-container confirmation",
                      icon: "swal-confirmation-icon",
                  }
                : [],
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: "",
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    allowEnterKey: false,
                    onOpen: () => {
                        Swal.showLoading();
                    },
                });

                let data = {};
                data.agent_id = this.props.currentUser.data.id;
                data.name = this.state.personalInfo.real_name;

                this.props.updateAgentName(data);
            }
        });
    };

    secondsToTime(secs) {
        let hours = Math.floor(secs / (60 * 60));

        let divisor_for_minutes = secs % (60 * 60);
        let minutes = Math.floor(divisor_for_minutes / 60);

        let divisor_for_seconds = divisor_for_minutes % 60;
        let seconds = Math.ceil(divisor_for_seconds);

        let obj = {
            h: hours,
            m: minutes,
            s: seconds.toString().padStart(2, "0"),
        };
        return obj;
    }

    startTimer() {
        if (this.state.timer === 0 && this.state.seconds > 0) {
            this.timer = setInterval(this.countDown, 1000);
        }
    }

    countDown = () => {
        // Remove one second, set state so a re-render happens.
        let seconds = this.state.seconds - 1;

        this.setState({
            time: this.secondsToTime(seconds),
            seconds: seconds,
        });

        // Check if we're at zero.
        if (seconds === 0) {
            clearInterval(this.timer);
            this.setState({
                resend_otp_button_disabled: false,
                disabled_resend_contact_no: false,
            });
        }
    };

    updateLoginPasswordHandler = (e) => {
        const { t } = this.props;

        if (isDesktop) {
            Swal.fire({
                title: t("global.confirmation"),
                text: t("global.would-you-like-to-proceed") + "?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: t("global.confirm"),
                cancelButtonText: t("global.cancel"),
            }).then((result) => {
                if (result.isConfirmed) {
                    Swal.fire({
                        title: "",
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        allowEnterKey: false,
                        didOpen: () => {
                            Swal.showLoading();
                        },
                    });

                    let data = {};
                    data.current_password = e.current_password;
                    data.new_password = e.new_password;
                    data.confirm_password = e.confirm_password;
                    data.trxTime = moment().unix();
                    data.trxHash = this.hashingAlg(data);
                    this.props.updateMemberPassword(data);
                }
            });
        } else {
            Swal.fire({
                iconHtml: '<img src="https://api.iconify.design/ic:outline-question-mark.svg?color=%23ffffff">',
                icon: "warning",
                title: t("global.confirmation"),
                text: t("global.would-you-like-to-proceed") + "?",
                showCancelButton: true,
                confirmButtonText: t("global.confirm"),
                cancelButtonText: t("global.cancel"),
                customClass: {
                    container: "swal-mobile-container confirmation",
                    icon: "swal-confirmation-icon",
                },
            }).then((result) => {
                if (result.isConfirmed) {
                    Swal.fire({
                        title: "",
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        allowEnterKey: false,
                        didOpen: () => {
                            Swal.showLoading();
                        },
                    });

                    let data = {};
                    data.current_password = e.current_password;
                    data.new_password = e.new_password;
                    data.confirm_password = e.confirm_password;
                    data.trxTime = moment().unix();
                    data.trxHash = this.hashingAlg(data);
                    this.props.updateMemberPassword(data);
                }
            });
        }
    };

    setPaymentPasswordHandler = (e) => {
        const { t } = this.props;
        e.preventDefault();
        if (isDesktop) {
            Swal.fire({
                title: t("global.confirmation"),
                text: t("global.would-you-like-to-proceed") + "?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: t("global.confirm"),
                cancelButtonText: t("global.cancel"),
            }).then((result) => {
                if (result.isConfirmed) {
                    Swal.fire({
                        title: "",
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        allowEnterKey: false,
                        didOpen: () => {
                            Swal.showLoading();
                        },
                    });

                    let data = {};
                    data.payment_password = this.state.payment_password;
                    data.trxTime = moment().unix();
                    data.trxHash = this.hashingAlg(data);
                    this.props.setAgentPaymentPassword(data);
                }
            });
        } else {
            Swal.fire({
                iconHtml: '<img src="https://api.iconify.design/ic:outline-question-mark.svg?color=%23ffffff">',
                icon: "warning",
                title: t("global.confirmation"),
                text: t("global.would-you-like-to-proceed") + "?",
                showCancelButton: true,
                confirmButtonText: t("global.confirm"),
                cancelButtonText: t("global.cancel"),
                customClass: {
                    container: "swal-mobile-container confirmation",
                    icon: "swal-confirmation-icon",
                },
            }).then((result) => {
                if (result.isConfirmed) {
                    Swal.fire({
                        title: "",
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        allowEnterKey: false,
                        didOpen: () => {
                            Swal.showLoading();
                        },
                    });

                    let data = {};
                    data.payment_password = this.state.payment_password;
                    data.trxTime = moment().unix();
                    data.trxHash = this.hashingAlg(data);
                    this.props.setAgentPaymentPassword(data);
                }
            });
        }
    };

    updatePaymentPasswordHandler = (e) => {
      const { t } = this.props;
      e.preventDefault();
      if (isDesktop) {
          Swal.fire({
              title: t("global.confirmation"),
              text: t("global.would-you-like-to-proceed") + "?",
              icon: "warning",
              showCancelButton: true,
              confirmButtonText: t("global.confirm"),
              cancelButtonText: t("global.cancel"),
          }).then((result) => {
              if (result.isConfirmed) {
                  Swal.fire({
                      title: "",
                      allowOutsideClick: false,
                      allowEscapeKey: false,
                      allowEnterKey: false,
                      didOpen: () => {
                          Swal.showLoading();
                      },
                  });

                  let data = {};
                  data.payment_password = this.state.payment_password;
                  data.trxTime = moment().unix();
                  data.trxHash = this.hashingAlg(data);
                  this.props.updateAgentPaymentPassword(data);
              }
          });
      } else {
          Swal.fire({
              iconHtml: '<img src="https://api.iconify.design/ic:outline-question-mark.svg?color=%23ffffff">',
              icon: "warning",
              title: t("global.confirmation"),
              text: t("global.would-you-like-to-proceed") + "?",
              showCancelButton: true,
              confirmButtonText: t("global.confirm"),
              cancelButtonText: t("global.cancel"),
              customClass: {
                  container: "swal-mobile-container confirmation",
                  icon: "swal-confirmation-icon",
              },
          }).then((result) => {
              if (result.isConfirmed) {
                  Swal.fire({
                      title: "",
                      allowOutsideClick: false,
                      allowEscapeKey: false,
                      allowEnterKey: false,
                      didOpen: () => {
                          Swal.showLoading();
                      },
                  });

                  let data = {};
                  data.payment_password = this.state.payment_password;
                  data.trxTime = moment().unix();
                  data.trxHash = this.hashingAlg(data);
                  this.props.updateAgentPaymentPassword(data);
              }
          });
      }
  };

    hashingAlg = (inputArr) => {
        let toHashStr = "";
        let hashStr = "";
        let paramsKey = [];
        Object.keys(inputArr).forEach((item) => {
            if (inputArr[item] !== "") {
                paramsKey.push(item);
            }
        });
        paramsKey.sort();
        paramsKey.forEach((val) => {
            let x = inputArr[val];
            if (x !== "") {
                toHashStr += val + x;
            }
        });
        toHashStr += process.env.REACT_APP_HASH_SECRET;
        hashStr = CryptoJS.MD5(toHashStr).toString();
        return hashStr;
    };

    onInputChange = (e) => {
        this.setState({
            payment_password: e,
        });
    };

    onForgetPaymentPasswordHandler = () => {

        this.toggleEditModal("mobile_no");

        this.setState({
            openEditModal: true,
            forgetPaymentPasswordStatus: true
        });
    };

    removePaymentPasswordHandler = (e) => {
        e.preventDefault();

        this.toggleEditModal("remove_payment_password");

        this.setState({
            openEditModal: true,
        });
    }

    onRemovePaymentPasswordHandler = (event) => {
        event.preventDefault();

        const { t } = this.props;

        Swal.fire({
            iconHtml: !isDesktop ? '<img src="https://api.iconify.design/ic:outline-question-mark.svg?color=%23ffffff">' : "",
            title: t("global.confirmation"),
            text: t("global.would-you-like-to-proceed") + "?",
            icon: "warning",
            confirmButtonText: t("global.confirm"),
            showDenyButton: true,
            denyButtonText: t("global.cancel"),
            customClass: !isDesktop
                ? {
                    container: "swal-mobile-container confirmation",
                    icon: "swal-confirmation-icon",
                }
                : [],
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    allowEnterKey: false,
                    didOpen: () => {
                        Swal.showLoading();
                    },
                });

                const data = {};

                data.payment_password = this.state.payment_password;

                this.props.removePaymentPassword(data);
            }
        });

    }

    onEditPaymentPasswordHandler = (event) => {
        event.preventDefault();

        const { t } = this.props;

        Swal.fire({
            iconHtml: !isDesktop ? '<img src="https://api.iconify.design/ic:outline-question-mark.svg?color=%23ffffff">' : "",
            title: t("global.confirmation"),
            text: t("global.would-you-like-to-proceed") + "?",
            icon: "warning",
            confirmButtonText: t("global.confirm"),
            showDenyButton: true,
            denyButtonText: t("global.cancel"),
            customClass: !isDesktop
                ? {
                    container: "swal-mobile-container confirmation",
                    icon: "swal-confirmation-icon",
                }
                : [],
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    allowEnterKey: false,
                    didOpen: () => {
                        Swal.showLoading();
                    },
                });

                const data = {};

                data.payment_password = this.state.payment_password;

                this.props.verifyPaymentPassword(data);
            }
        });
    };

    render() {
        const { t } = this.props;
        const fadeUp = keyframes`
        from {
        opacity: 0;
        transform: translate3d(0, 50px ,0);
        }

        to {
        opacity: 1;
        transform: translate3d(0, 0, 0);
        }
    `;

        switch (this.props.currentUser.country_id) {
            case "1":
                contact_no_min_limits = 9;
                contact_no_max_limits = 13;
                break;
            case "3":
                contact_no_min_limits = 8;
                contact_no_max_limits = 8;
                break;
            case "4":
                contact_no_min_limits = 10;
                contact_no_max_limits = 10;
                break;
            case "5":
                contact_no_min_limits = 9;
                contact_no_max_limits = 9;
                break;
            case "7":
                contact_no_min_limits = 10;
                contact_no_max_limits = 10;
                break;
            default:
                break;
        }

        let resendOTPCountDownTimer;

        if (this.state.resend_otp_button_disabled === true) {
            resendOTPCountDownTimer = "0" + this.state.time.m + ":" + this.state.time.s;
        } else {
            if (isDesktop) {
                resendOTPCountDownTimer = t("top-profile.resend");
            } else {
                resendOTPCountDownTimer = "0" + this.state.time.m + ":" + this.state.time.s;
            }
        }

        return (
            <>
                {isDesktop ? (
                    <section className="pf-dashboard">
                        <EditModal
                            {...this.state}
                            toggleEditModal={this.toggleEditModal}
                            enterRealName={this.enterRealName}
                            updateRealName={this.updateRealName}
                            enterMobileNumber={this.enterMobileNumber}
                            updateMobileNumber={this.updateMobileNumber}
                            enterEmail={this.enterEmail}
                            verifyEmail={this.verifyEmail}
                            generateEmailOTP={this.generateEmailOTPHandler}
                            enterMobileVarificationCode={this.enterMobileVarificationCode}
                            enterEmailVarificationCode={this.enterEmailVarificationCode}
                            enterPaymentOldPass={this.enterPaymentOldPass}
                            enterPaymentNewPass={this.enterPaymentNewPass}
                            enterPaymentConfirmPass={this.enterPaymentConfirmPass}
                            updatePaymentPassword={this.updatePaymentPassword}
                            enterLoginOldPass={this.enterLoginOldPass}
                            enterLoginNewPass={this.enterLoginNewPass}
                            enterLoginConfirmPass={this.enterLoginConfirmPass}
                            updateLoginPassword={this.updateLoginPassword}
                            updateAgentName={this.updateAgentNameHandler}
                            countryArry={countryArry}
                            contactNoMinLimits={contact_no_min_limits}
                            contactNoMaxLimits={contact_no_max_limits}
                            generateOTPHandler={this.generateOTPHandler}
                            resendOTPCountDownTimer={resendOTPCountDownTimer}
                            verifyOtpHandler={this.verifyOtpHandler}
                            resendOTPHandler={this.resendOTPHandler}
                            updateLoginPasswordHandler={this.updateLoginPasswordHandler}
                            setPaymentPasswordHandler={this.setPaymentPasswordHandler}
                            updatePaymentPasswordHandler={this.updatePaymentPasswordHandler}
                            onInputChange={this.onInputChange}
                            onForgetPaymentPasswordHandler={this.onForgetPaymentPasswordHandler}
                            onRemovePaymentPasswordHandler={this.onRemovePaymentPasswordHandler}
                            onEditPaymentPasswordHandler={this.onEditPaymentPasswordHandler}
                        />
                        <div className="x-container mt-3">
                            <SideBar />
                            {!this.state.showBindingAuth && !this.state.showEditSecurityAns ? (
                                <Reveal className="pf-fade-col" keyframes={fadeUp} duration={1000} triggerOnce>
                                    <div className="row g-3">
                                        <div className="col-12">
                                            <div className="pd-card-col h-100">
                                                <h4 className="mb-5">{t("personal-details.title")}</h4>
                                                <div className="pd-content">
                                                    <div className="pi-col mb-4">
                                                        <h5>{t("page-header.personal-information")}</h5>
                                                        <div className="pi-row">
                                                            <label className="pi-w-25">{t("personal-details.username")}</label>
                                                            <p className="pi-w-25">{this.state.personalInfo.name}</p>
                                                        </div>
                                                        <div className="pi-row">
                                                            <label className="pi-w-25">{t("personal-details.real-name")}</label>
                                                            <p className="pi-w-25">{this.state.personalInfo.real_name}</p>
                                                            <div className="pi-edit-verified">
                                                                {this.state.personalInfo.real_name === "" && (
                                                                    <button className="btn btn-outline-blue" onClick={() => this.toggleEditModal("real_name")}>
                                                                        {t("personal-details.edit")}
                                                                    </button>
                                                                )}
                                                            </div>
                                                        </div>
                                                        <div className="pi-row">
                                                            <label className="pi-w-25">{t("personal-details.mobile-no")}</label>
                                                            <p className="pi-w-25">{this.state.personalInfo.mobile_no}</p>
                                                            <div className="pi-edit-verified">
                                                                <button className="btn btn-outline-blue" onClick={() => this.toggleEditModal("mobile_no")}>
                                                                    {t("personal-details.edit")}
                                                                </button>

                                                                {this.state.contactVerifiedStatus === 1 && <span className="btn btn-outline-green">{t("personal-details.verify")}</span>}
                                                            </div>
                                                        </div>
                                                        <div className="pi-row">
                                                            <label className="pi-w-25">{t("personal-details.email")}</label>
                                                            <p className="pi-w-25">{this.state.personalInfo.email}</p>
                                                            <div className="pi-edit-verified">
                                                                <button className="btn btn-outline-blue" onClick={() => this.toggleEditModal("email")}>
                                                                    {t("personal-details.edit")}
                                                                </button>

                                                                {this.state.emailVerifiedStatus === 1 && <span className="btn btn-outline-green">{t("personal-details.verify")}</span>}
                                                            </div>
                                                        </div>
                                                        <div className="pi-row">
                                                            <label className="pi-w-25">{t("personal-details.birthday")}</label>
                                                            {this.state.personalInfo.birthday ? (
                                                                <p className="pi-w-25">{this.state.personalInfo.birthday}</p>
                                                            ) : (
                                                                <DatePicker
                                                                    selected={this.state.birthday}
                                                                    onSelect={(date) => this.setBirthdayDay(date)}
                                                                    onChange={(date) => this.setBirthdayDay(date)}
                                                                    dateFormat="dd-MM-yyyy"
                                                                    placeholderText="Click to select a date"
                                                                />
                                                            )}

                                                            <div className="pi-edit-verified">
                                                                <Icon icon="material-symbols:event-note-outline" />
                                                                {this.state.birthday !== "" && !this.state.personalInfo.birthday && (
                                                                    <button className="btn btn-outline-blue ms-2" onClick={this.updatePersonalInfo}>
                                                                        {t("personal-details.save")}
                                                                    </button>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="pi-col mb-4">
                                                        <h5>{t("page-header.personal-information")}</h5>
                                                        <div className="pi-row">
                                                            <label className="pi-w-25">{t("personal-details.payment-password")}</label>
                                                            <div className="pi-w-25">
                                                                <button className="btn btn-outline-blue" onClick={() => (this.state.paymentPasswordStatus === 0) ? this.toggleEditModal("payment_pass") : this.toggleEditModal("update_payment_password") }>
                                                                    {t("personal-details.edit")}
                                                                </button>
                                                                {this.state.paymentPasswordStatus === 1 && (
                                                                    <span className="btn btn-outline-red" onClick={this.removePaymentPasswordHandler}>
                                                                        {t("personal-details.remove")}
                                                                    </span>
                                                                )}
                                                            </div>
                                                            <div className="pi-edit-verified">
                                                                <p>{t("personal-details.remark-payment-password")}</p>
                                                            </div>
                                                        </div>
                                                        <div className="pi-row">
                                                            <label className="pi-w-25">{t("personal-details.login-password")}</label>
                                                            <div className="pi-w-25">
                                                                <button className="btn btn-outline-blue" onClick={() => this.toggleEditModal("login_pass")}>
                                                                    {t("personal-details.edit")}
                                                                </button>
                                                            </div>
                                                            <div className="pi-edit-verified">
                                                                <p>{t("personal-details.remark-login-password")}</p>
                                                            </div>
                                                        </div>
                                                        {/* <div className="pi-row">
                                                            <label className="pi-w-25">Security Question</label>
                                                            <div className="pi-w-25">
                                                                <button className="btn btn-outline-blue" onClick={() => this.setState({ showEditSecurityAns: true })}>
                                                                    Edit
                                                                </button>
                                                            </div>
                                                            <div className="pi-edit-verified">
                                                                <p>An important basis for retrieving your security information</p>
                                                            </div>
                                                        </div> */}
                                                        {/* <div className="pi-row">
                                                            <label className="pi-w-25">Authentication</label>
                                                            <div className="pi-w-25">
                                                                {this.state.googleAuthenticateStatus === 0 ? (
                                                                    <button className="btn btn-outline-blue" onClick={() => this.setState({ showBindingAuth: true })}>
                                                                        Edit
                                                                    </button>
                                                                ) : (
                                                                    <>
                                                                        <span className="btn btn-outline-green">Verify</span>
                                                                        <span className="btn btn-outline-red" onClick={this.deactiveGoogleAuthenticator}>
                                                                            Disable
                                                                        </span>
                                                                    </>
                                                                )}
                                                            </div>
                                                            <div className="pi-edit-verified">
                                                                <p>Strengthen the security of account fund withdrawal</p>
                                                            </div>
                                                        </div> */}
                                                    </div>
                                                    <div className="pi-col">
                                                        <h5>{t("personal-details.agent-information")}</h5>
                                                        <div className="pi-row">
                                                            <label className="pi-w-25">{t("personal-details.subordinate-members")}</label>
                                                            <p className="pi-w-25">{this.state.subordinateMembers}</p>
                                                        </div>
                                                        <div className="pi-row">
                                                            <label className="pi-w-25">{t("personal-details.join-venture-code")}</label>
                                                            <p className="pi-w-25">{this.state.referralCode}</p>
                                                        </div>
                                                        <div className="pi-row">
                                                            <label className="pi-w-25">Downline Agents</label>
                                                            <p className="pi-w-25">{this.state.downlineAgents}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Reveal>
                            ) : this.state.showBindingAuth ? (
                                <BindingAuth backToPersonalDetails={this.backToPersonalDetails} />
                            ) : (
                                this.state.showEditSecurityAns && <EditSecurityAns backToPersonalDetails={this.backToPersonalDetails} />
                            )}
                        </div>
                    </section>
                ) : (
                    <MobilePersonalDetails 
                        {...this.state} 
                        countryArry={countryArry}
                        onChangeDateHandler={this.onChangeDateHandler}
                        updateAgentName={this.updateAgentNameHandler}
                        enterRealName={this.enterRealName}
                        updatePersonalInfo={this.updatePersonalInfo}
                        enterEmail={this.enterEmail}
                        verifyEmail={this.verifyEmail}
                        generateEmailOTP={this.generateEmailOTPHandler}
                        enterEmailVarificationCode={this.enterEmailVarificationCode}
                        enterMobileNumber={this.enterMobileNumber}
                        updateMobileNumber={this.updateMobileNumber}
                        contactNoMinLimits={contact_no_min_limits}
                        contactNoMaxLimits={contact_no_max_limits}
                        generateOTPHandler={this.generateOTPHandler}
                        resendOTPCountDownTimer={resendOTPCountDownTimer}
                        verifyOtpHandler={this.verifyOtpHandler}
                        resendOTPHandler={this.resendOTPHandler}
                        enterMobileVarificationCode={this.enterMobileVarificationCode}
                        enterLoginOldPass={this.enterLoginOldPass}
                        enterLoginNewPass={this.enterLoginNewPass}
                        enterLoginConfirmPass={this.enterLoginConfirmPass}
                        updateLoginPasswordHandler={this.updateLoginPasswordHandler}
                        setPaymentPasswordHandler={this.setPaymentPasswordHandler}
                        updatePaymentPasswordHandler={this.updatePaymentPasswordHandler}
                        onInputChange={this.onInputChange}
                        onForgetPaymentPasswordHandler={this.onForgetPaymentPasswordHandler}
                        onRemovePaymentPasswordHandler={this.onRemovePaymentPasswordHandler}
                        onEditPaymentPasswordHandler={this.onEditPaymentPasswordHandler}
                    />
                )}
            </>
        );
    }
}

const mapStateToProps = (state) => {
    const { profile, home } = state;
    return {
        currentUser: state.currentUser,
        deactive_google_authenticator: profile.deactive_google_authenticator,
        get_agent_profile: profile.get_agent_profile,
        update_agent_name: profile.update_agent_name,
        update_agent_dob: profile.update_agent_dob,
        generate_email_otp_result: profile.generate_email_otp_result,
        verify_email_otp_result: profile.verify_email_otp_result,
        countryData: home.country_data,
        generate_sms_otp_result: profile.generate_sms_otp_result,
        verify_sms_otp_result: profile.verify_sms_otp_result,
        resend_otp_result: profile.resend_otp_result,
        member_update_password_result: profile.member_update_password_result,
        set_agent_payment_password_result: profile.set_agent_payment_password_result,
        update_agent_payment_password_result: profile.update_agent_payment_password_result,
        remove_payment_password_result: profile.remove_payment_password_result,
        verify_payment_password_result: profile.verify_payment_password_result
    };
};

const mapDispatchToProps = {
    getUserData,
    deactiveGoogleAuthenticator,
    getAgentProfile,
    updateAgentName,
    updateAgentDOB,
    generateEmailOTP,
    verifyEmailOTP,
    getCountry,
    generateSMSOTP,
    verifySMSOTP,
    resendOTP,
    updateMemberPassword,
    setAgentPaymentPassword,
    updateAgentPaymentPassword,
    removePaymentPassword,
    verifyPaymentPassword
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withNamespaces("translation")(PersonalDetails)));
